import * as React from "react";
import { HighlightedContent, HighlightedContentItem } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachPageable } from "../../../../hocs/hocs/with-bloomreach-pageable.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
const CmsBlogCollectionItem = withEditableContent(({ content }) => {
  const { title, summary, url } = content;
  const coverImage = parseBloomreachImage(content.coverImage);
  const [link] = useBloomreachLinks([{ url: url ?? "#" }]);
  if (!coverImage) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(HighlightedContentItem, { image: coverImage.original, title, text: summary, link });
});
const CmsBlogCollection = ({ content }) => /* @__PURE__ */ React.createElement(HighlightedContent, null, content.items.map((item) => /* @__PURE__ */ React.createElement(CmsBlogCollectionItem, { key: item.id, content: item })));
const BlogCollection = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachPageable,
  withAnchor
)(CmsBlogCollection);
export {
  CmsBlogCollection,
  CmsBlogCollectionItem,
  BlogCollection as default
};
//# sourceMappingURL=BlogCollection.js.map
